module.exports = __webpack_public_path__ + "img/edit_pencil.620973b0.svg";